module.exports = __webpack_public_path__ + "d5404be3c71291c865d1bbb6b33da9a8.pdf";